import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { themeManager, type ThemeMode } from '@/services/theme/theme-manager'

export const useThemeStore = defineStore('theme', () => {
    const mode = ref<ThemeMode>('auto')

    // Computed properties
    const isDarkMode = computed(() => themeManager.isDarkMode())
    const systemTheme = computed(() => themeManager.detectSystemTheme())

    // Actions
    function setMode(themeMode: ThemeMode) {
        mode.value = themeMode
    }

    async function setTheme(theme: ThemeMode) {
        await themeManager.setTheme(theme)
    }

    function applyTheme(theme?: ThemeMode) {
        themeManager.applyTheme(theme)
    }

    async function initializeTheme() {
        // Load theme from storage and apply it
        await themeManager.initialize()
        // Update store with loaded theme
        mode.value = themeManager.getCurrentTheme()
        // Setup system theme listener for auto mode
        themeManager.setupSystemThemeListener()
    }

    function cleanup() {
        themeManager.removeSystemThemeListener()
    }

    return {
        // State
        mode,

        // Computed
        isDarkMode,
        systemTheme,

        // Actions
        setMode,
        setTheme,
        applyTheme,
        initializeTheme,
        cleanup
    }
})
